import React,{Component} from 'react';

class Home extends Component {

    render(){
        return(
            <div>
                <br></br>
                <h1>
                    Hello This is Home Page
                </h1>

            </div>
        )
    }
}

export default Home;